<template>
    <!-- App -->
    <f7-app :params="f7params" v-bind:class="{'theme-dark':theme}" :color-theme="color_theme">
        <!-- <f7-app :params="f7params"> -->

        <!-- Statusbar -->
        <f7-statusbar />

        <!-- Left Panel -->
        <f7-panel left reveal>
            <f7-view url="/panel-left/">
                <sa-c-nav title="Menu" />
                <f7-block-title>DEV STUFF</f7-block-title>

                <f7-list>
                    <f7-list-item view="#main-view" link="/" title="Front" />
                    <f7-list-item view="#main-view" link="/area51/" title="Area51" />
                    <f7-list-item view="#main-view" link="/area52/" title="Area52" />
                    <f7-list-item view="#main-view" link="/sa-t-sa-settings/" title="SA-INFO" />
                    <f7-list-item view="#main-view" link="/sa-platform-editor/?editor=true" title="Editor" />
                </f7-list>

            </f7-view>
        </f7-panel>

        <!-- Right Panel -->
        <sac-c-kodinpro-rightmenu />

        <!-- Main View -->
        <f7-view id="main-view" :push-state="true" url="/" main />

    </f7-app>
</template>

<script>
import VRuntimeTemplate from "v-runtime-template";
import SAF7AppCore from "@sa-platform/sa-p-core/framework7-app-core.vue";
import {mapState} from "vuex";
import axios from "axios";
import * as analytics from "./analytics";

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

export default {

    extends: SAF7AppCore,
    data() {
        return {

            template1: "<p></p>",
            // Framework7 parameters here
            f7params: {
                id: "fi.yeoman.kodinpro", // App bundle ID
                name: "KodinPRO", // App name,
                view: {
                    animate: false,
                    iosDynamicNavbar: false
                },
                touch: {
                    materialRipple: false
                },
                // theme: "md",
                pushState: true
            }
        };
    },
    computed: {
        ...mapState(["user", "subscriptionValidity", "subscriptionInfo"])
    },
    watch: {
        async user() {
            console.log("watch user", this.user);

            if(this.user) {
                console.log(this.$f7);
                console.log("userchange");
                this.$store.commit("setBookings", []);
                await this.$store.dispatch("loadRequests");
                if(!window.location.href.includes("/register/")) {
                    const roles = this.user.data.roles;
                    if(this.isContractor(roles)) this.contractorRedirect();
                    else if(this.isCustomer(roles)) this.customerRedirect();
                }
            } else if(this.user === null) {
                this.defaultRouting();
            }
        }
    },
    methods: {
        async maybeRefreshUser() {
            const refreshToken = localStorage.getItem("refresh_token");
            if(!refreshToken) return;

            await window.SAPlatform.session.fetchTokens("refresh_token", {
                refresh_token: refreshToken
            });

            window.SAPlatform.user.init();

            const user = window.SAPlatform.user.current();

            if(user) {
                this.$store.commit("setUser", user);
            }
        },
        initAnalytics() {
            const router = this.$f7.views.main.router;
            router.on("pageAfterIn", page => analytics.logScreen(page));
        },
        isContractor(roles) {
            return roles.indexOf("contractor") !== -1;
        },
        isCustomer(roles) {
            return roles.indexOf("customer") !== -1;
        },
        customerRedirect() {
            if(parseInt(localStorage.getItem("termsAccepted")) == 1) {
                if(this.$store.state.isBrowser) this.$f7.views.main.router.navigate("/main-customer/");
                else if(!this.$store.state.isBrowser) {
                    this.$f7.dialog.alert("Sovellus ei vaadi kirjautumista kuluttaja-asiakkaana. Voit käyttää sovellusta ilman rekisteröitymistä.");
                    this.$store.dispatch("logOut");
                }
            } else {
                this.$f7.views.main.router.navigate("/info/");
            }
        },
        async contractorRedirect() {
            console.log("contractorRedirect");
            this.$store.dispatch("loadContractorInfo");
            await this.$store.dispatch("loadContractorSubscriptionStatus");

            if(parseInt(localStorage.getItem("termsAccepted")) == 1) {
                if(this.subscriptionValidity) {
                    this.$store.dispatch("loadCompanyBookings");
                    this.$f7.views.main.router.navigate("/opened-requests/", {clearPreviousHistory: true});
                } else if(this.subscriptionInfo.joinFeePaid) {
                    this.$f7.views.main.router.navigate("/opened-requests/", {clearPreviousHistory: true});
                } else {
                    this.$f7.views.main.router.navigate("/inactive-contractor/", {clearPreviousHistory: true});
                }
            } else {
                this.$f7.views.main.router.navigate("/info/");
            }
        },
        getDeviceToken() {
            return new Promise((resolve, reject) => {
                if(!window.FirebasePlugin) {
                    reject(new Error("FireBasePlugin is unavailable"));
                    return;
                }

                window.FirebasePlugin.getToken(token => resolve(token));
            });
        },
        getDeviceUuid() {
            return new Promise(resolve => {
                window.plugins.uniqueDeviceID.get(uuid => resolve(uuid));
            });
        },
        deviceReady() {
            return new Promise(resolve => {
                document.addEventListener("deviceready", () => resolve());
            });
        },
        async registerPushHandlers() {
            await this.deviceReady();
            window.FirebasePlugin.onMessageReceived(notification => {
                if(notification.tap === "background") this.handleNotificationAction(notification);
                else this.handleForegroundNotification(notification);
            });
        },
        handleNotificationAction(notification) {
            console.log("handleNotificationAction", notification);
            const currentUser = SAPlatform.user.current();

            if(notification.action === "navigateView") {
                if(notification.role) {
                    if(!currentUser || !currentUser.data || !currentUser.data.roles.includes(notification.role)) {
                        return;
                    }
                }

                this.$f7.views.main.router.navigate(notification.view);
            }
        },
        handleForegroundNotification(notification) {
            if(!notification.title || !notification.body) return;
            const notice = this.$f7.notification.create({
                title: notification.title,
                text: notification.body,
                closeTimeout: 15000,
                closeOnClick: true,
                on: {
                    click: () => this.handleNotificationAction(notification)
                }
            });

            notice.open();
        },
        askPushPermission() {
            if(!window.FirebasePlugin) return;
            if(!window.FirebasePlugin.grantPermission) return;

            window.FirebasePlugin.grantPermission();
        },
        async registerDeviceForUser() {
            try {
                await this.deviceReady();
                const deviceToken = await this.getDeviceToken();

                const url = window.SAPlatform.server.url + "wp-json/kodinpro/v1/device";
                axios.put(url, {deviceToken});
            } catch(e) {
                console.warn(e);
            }
        },
        async registerDevice() {
            try {
                await this.deviceReady();
                const [deviceToken, deviceUuid] = await Promise.all([
                    this.getDeviceToken(),
                    this.getDeviceUuid(),
                ]);

                const url = window.SAPlatform.server.url + "wp-json/kodinpro/v1/device";
                axios.put(url, {deviceToken}, {
                    headers: {
                        "X-App-Uuid": deviceUuid
                    }
                });
            } catch(e) {
                console.warn(e);
            }
        },
        async initVuexStore() {
            try {
                await Promise.all([
                    this.$store.dispatch("loadCompanies"),
                    this.$store.dispatch("loadUuid"),
                    this.$store.dispatch("loadCategories"),
                    this.$store.dispatch("loadRegions"),
                ]);
            } catch(e) {
                console.error(e);
                this.$f7.dialog.alert("Jokin meni väärin");
            }
        },
        urlInIgnore(url, ignores) {
            let urlInIgnore = false;
            ignores.forEach(ignore => {
                if(url && url.includes(ignore)) urlInIgnore = true;
            });
            return urlInIgnore;
        },
        async defaultRouting() {
            console.log("This default routing");
            const router = this.$f7.views.main.router;
            const ignores = ["register", "registercustomer", "inactive-contractor", "info", "reset-password"];

            const ignored = ignores.some(i => window.location.hash.includes(i));
            if(ignored) return;
            await this.$nextTick();
            router.navigate("/main-customer/", {clearPreviousHistory: true});
        },
        policies() {
            const self = this;
            return new Promise((resolve) => {
                self.$f7.dialog.create({
                    text: `Jatkamalla palvelun käyttöä hyväksyt
                  <a class="external" onclick="window.open('https://kodinpro.fi/tietosuoja','_system')">
                    tietosuojakäytänteet
                  </a>
                  ja
                  <a class="external" onclick="window.open('https://kodinpro.fi/wp-content/uploads/2019/03/KodinPro_kayttoehdot.pdf','_system')" >
                    käyttöehdot</a>.`,
                    title: "KodinPro",
                    buttons: [
                        {
                            text: "Hyväksy",
                            onClick: resolve
                        },
                    ]
                }).open();
            });
        }

    },
    async created() {
        const isBrowser = this.$store.state.isBrowser;
        const user = window.SAPlatform.user.current();

        if(user) {
            this.$store.commit("setUser", user);
        } else {
            try {
                await this.maybeRefreshUser();
            } catch(e) {
                console.warn("Failed to refresh user", e);
            }
        }

        if(!isBrowser) {
            this.askPushPermission();
            this.registerDevice();
            this.registerPushHandlers();
        }

        this.listen("user-session-expired", () => {
            this.registerDevice();
            this.$store.commit("setUser", null);
        });

        this.listen("user-session-init", () => {
            if(!isBrowser) this.registerDeviceForUser();
            console.log("Own user-session-init");
            console.log(this.$store);
            this.$store.commit("setUser", window.SAPlatform.user.current());
        });

        this.initVuexStore();
    },
    async mounted() {
        this.initAnalytics();
        window.f7 = this.$f7;
        if("cordova" in window && !localStorage.getItem("policyAccepted")) {
            console.log("policies show up");
            await this.policies();
            localStorage.setItem("policyAccepted", true);
        }

        if(!("cordova" in window) && iNoBounce && document.querySelector("html").classList.contains("ios")) {
            iNoBounce.enable();
        }

        const hasAuthenticationInfo = localStorage.getItem("access_token") && localStorage.getItem("refresh_token");
        if(!hasAuthenticationInfo) {
            this.defaultRouting();
        }

        if(!this.$store.state.isBrowser) {
            this.$f7.view.main.router.on("routeChange", route => {
                if(route.path === "/") {
                    const platform = navigator.app || navigator.device;
                    platform.exitApp();
                }
            });
        }
    }
};
</script>
<style>
</style>
